export const API_CONFIG = {
  TMDB: {
    TRENDING_URL: '/api/trending',
    SEARCH_URL: '/api/search',
    DETAILS_URL: '/api/details',
  },
  PROGRAMACAO: {
    URL: '/api/programacao',
  },
  JOGOS: {
    URL: '/api/jogos',
  },
  ASSISTANT: {
    URL: '/api/assistant',
  },
  GEMINI: {
    RECOMMENDATIONS_URL: '/api/recommendations',
  }
};
